// lib
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Button, List } from "@material-ui/core";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { filter } from "ramda";
// src
import Alert from "components/modals/partials/Alert";
import { PresetType } from "config/constants";
import DraggableCategory from "./DraggableCategory";

const filterCategories = filter((item) => item.type === PresetType.CATEGORY);

const CategoryList = ({
  // parent props
  dispatch,
  items,
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const [openRemoveConfirm, setOpenRemoveConfirm] = useState(false);
  const [removeConfirmCallback, setRemoveConfirmCallback] = useState(null);
  const { t } = useTranslation();
  const categories = filterCategories(items);
  // UX

  const handleOpenRemove = (category) => () => {
    if (!category.childrenCount || category.childrenCount === 0) {
      dispatch({ type: "remove", index: category.index });
    } else {
      setOpenRemoveConfirm(true);
      // callback wrapping needed
      setRemoveConfirmCallback(() => () => {
        dispatch({ type: "remove", index: category.index });
        setOpenRemoveConfirm(false);
        setRemoveConfirmCallback(null);
      });
    }
  };
  const handleRemoveCancel = () => {
    setOpenRemoveConfirm(false);
    setRemoveConfirmCallback(null);
  };

  const handleAddCategory = () => {
    dispatch({ type: "addCategory" });
  };

  const handleDragStart = () => {
    setIsDragging(true);
  };

  const handleDragEnd = (result) => {
    setIsDragging(false);
    if (!result.destination) return;
    dispatch({ type: "move", from: result.source.index, to: result.destination.index });
  };

  const listClassName = isDragging ? "dragging categories" : "categories";
  return (
    <>
      {" "}
      <DragDropContext onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
        <Droppable droppableId="droppable">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              <List className={listClassName}>
                {categories.map((category) => (
                  <DraggableCategory
                    key={category.id}
                    category={category}
                    dispatch={dispatch}
                    onRemove={handleOpenRemove(category)}
                  />
                ))}
              </List>
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <div className="actions">
        <Button className="add-category" onClick={handleAddCategory} color="primary">
          {t("favorites.addCategory")}
        </Button>
      </div>
      <Alert
        open={openRemoveConfirm}
        cancelLabel={t("actions.cancel")}
        confirmLabel={t("actions.remove")}
        onCancel={handleRemoveCancel}
        onConfirm={removeConfirmCallback}
      >
        <p>{t("favorites.removeCategory")}</p>
      </Alert>
    </>
  );
};

CategoryList.propTypes = {
  // parents props
  dispatch: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
};

export default CategoryList;
